<template>
	<section class="deep-register-view">
		<link rel="stylesheet" href="https://use.typekit.net/rhi6acd.css" />
		<div
			class="deep-register-parts"
			v-if="institution"
			:style="{
				maxWidth: isLoggedIn && '480px',
				margin: isLoggedIn && 'auto'
			}"
		>
			<div class="deep-register-half">
				<v-row
					style="margin-bottom: 10px; margin-top: 0px"
					class="pr-4 pl-4"
				>
					<v-img
						src="../../assets/roundup_logo.svg"
						max-width="200"
						max-height="20"
						style="margin: auto"
					/>
					<v-spacer></v-spacer>
					<Roundup-Button
						v-if="!isLoggedIn"
						class="clear border"
						:style="{
							marginTop: 0,
							height: 32,
							padding: '5px 20px'
						}"
						color="white"
						@click="navigate({ name: 'login' }, 'up')"
						>Login
					</Roundup-Button>
				</v-row>
				<div class="deep-register-emotion">
					<div class="register-images">
						<img
							class="cover"
							:style="{ objectFit: isLoggedIn && 'cover' }"
							@error="downgradeImage"
							:src="image"
						/>
						<img class="logo" :src="institution.logo_url" />
					</div>
					<div class="register-body">
						<h1>{{ institution.impact_statement }}</h1>
						<p>
							Donating the spare change from your credit or debit
							card purchases allows us to
							{{ institution.full_impact_statement }}.
						</p>
						<p v-if="institution.signup_cta">
							<strong>{{ institution.signup_cta }}</strong>
						</p>
						<div
							class="register-form"
							style="margin-bottom: 10px"
							v-if="!isLoggedIn"
						>
							<form v-on:submit.prevent="onSubmit">
								<div v-if="!simpleForm">
									<label>
										<ui-input
											v-model="user.first_name"
											placeholder="First Name"
										/>
									</label>
									<label>
										<ui-input
											v-model="user.last_name"
											placeholder="Last Name"
										/>
									</label>
									<label>
										<p
											v-if="this.message"
											v-bind:style="{ fontSize: '12px' }"
										>
											{{ this.message }}
										</p>
										<ui-input
											v-model="user.phone"
											placeholder="Phone"
											@input="onlyNumber($event)"
										/>
									</label>
								</div>
								<label>
									<ui-input
										v-model="user.email"
										placeholder="Email"
									/>
								</label>
								<label v-if="!simpleForm">
									<ui-input
										v-model="user.password"
										placeholder="Password"
										type="password"
										native-type="password"
									/>
								</label>
								<label>
									<p class="terms">
										By continuing, I confirm I am a U.S.
										resident, 13 years or older and agree to
										the
										<a href="https://roundupapp.com/terms"
											>Terms of Use</a
										>.
									</p>
									<RoundupButton
										type="submit"
										color="primary"
										style="margin-top: 20px !important"
										:loading="isLoading"
										>Sign Up for RoundUps</RoundupButton
									>
								</label>
							</form>
						</div>
						<div v-else class="center">
							<hr style="width: 100%; border-color: #dcdee3" />
							<p style="text-align: left">
								Your funds are currently supporting the efforts
								of
								{{ cause.name }}.
							</p>
							<ui-button
								style="
									width: 100%;
									height: 52px;
									font-size: 20px;
									border-radius: 8px;
								"
								:loading="isLoading"
								@click="switchCause"
								>{{ loggedInCTA }}</ui-button
							>
							<a
								href="/#/logout"
								:style="{
									width: '100%',
									margin: 'auto',
									marginTop: '25px',
									fontSize: '14px'
								}"
								>Logout</a
							>
						</div>
						<a
							v-if="!isLoggedIn"
							class="terms"
							:style="{ marginTop: '10px', fontSize: '14px' }"
							href="#/login"
							>Already have an account? Login</a
						>
					</div>
				</div>
			</div>
			<div
				class="deep-register-half deep-register-steps"
				v-if="!isLoggedIn"
			>
				<h2>How Does It Work?</h2>
				<div class="step">
					<img src="../../assets/deeplink_step2.svg" />
					<h3><small>1.</small> Create Your Account</h3>
					<p>
						Just fill in your name, email address and a password of
						your choosing and you’re all set.
					</p>
				</div>
				<div class="step">
					<img src="../../assets/deeplink_step1.svg" />
					<h3><small>2.</small> Link Your Cards and Bank</h3>
					<p>
						Connect your credit or debit cards to the app and
						securely authorize RoundUps with your bank.
					</p>
				</div>
				<div class="step">
					<img src="../../assets/deeplink_step3.svg" />
					<h3><small>3.</small> Make an Impact</h3>
					<p>
						The extra change from each transaction you make will be
						"rounded up" and donated every month to
						{{ institution.name }}.
					</p>
				</div>
			</div>
		</div>
		<div v-if="noInstitution">
			<div
				:style="{
					display: flex,
					alignItems: center,
					width: '100%',
					textAlign: 'center'
				}"
			>
				<h1>Hi There!</h1>
				<h2>You've hit a custom page that isn't live.</h2>
				<p>
					This is either because this page isn't ready yet for public
					view, OR the nonprofit is no longer a client. If you
					believed that you received this page in error, please email
					<a href="mailto:support@roundupapp.com"
						>support@roundupapp.com</a
					>.
				</p>

				<p>
					If you're a donor looking to sign up, please register here:
					<a href="https://app.roundupapp.com/#/Register"
						>app.roundupapp.com/register</a
					>
				</p>
			</div>
		</div>
	</section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getUrlParams } from '../../utilities'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import { facebook } from '../../utilities/tracker'

export default {
	name: 'deep-register-view',
	components: { UiButton, UiInput },
	props: {
		uuid: String
	},
	data() {
		return {
			isLoading: false,
			noInstitution: false,
			user: {
				first_name: null,
				last_name: null,
				email: '',
				password: null,
				phone: null,
				institution: this.uuid,
				referred_by: null
			},
			institution: null,
			message: '',
			simpleForm: false,
			loggedInCTA: 'Switch my cause'
		}
	},
	computed: {
		...mapGetters(['isLoggedIn', 'cause']),
		title() {
			if (this.noInstitution) {
				return false
			}
			return 'Donate | ' + this.institution.name
		},
		description() {
			if (this.noInstitution) {
				return false
			}
			return (
				'Round up and donate your change to support ' +
				this.institution.name +
				'! Sign up in seconds to donate the change from your credit/debit card purchases so ' +
				this.institution.name +
				' can ' +
				this.institution.full_impact_statement +
				'.'
			)
		},
		image() {
			if (this.noInstitution) {
				return false
			}
			if (!this.institution.image_url) {
				this.navigate({ name: 'home' })
			}
			return this.appendToFilename(this.institution.image_url, '@2x')
		}
	},
	head: {
		title() {
			return {
				inner: this.title
			}
		},
		meta() {
			return [
				{ name: 'description', content: this.description },
				// Twitter
				{
					name: 'twitter:title',
					content: this.title,
					id: 'twitter_title'
				},
				{
					name: 'twitter:description',
					content: this.description,
					id: 'twitter_desc'
				},
				{
					name: 'twitter:image',
					content: this.image,
					id: 'twitter_image'
				},
				// Google+ / Schema.org
				{ itemprop: 'name', content: this.title, id: 'google_title' },
				{
					itemprop: 'description',
					content: this.description,
					id: 'google_desc'
				},
				{ itemprop: 'image', content: this.image, id: 'google_image' },
				// Facebook / Open Graph
				{ property: 'og:title', content: this.title, id: 'fb_title' },
				{
					property: 'og:description',
					content: this.description,
					id: 'fb_desc'
				},
				{ property: 'og:image', content: this.image, id: 'fb_image' }
			]
		}
	},
	methods: {
		...mapActions(['register', 'getInstitution', 'attachInstitution']),
		onSubmit() {
			this.isLoading = true
			this.register(this.user)
				.then((data) => {
					this.isLoading = false
					if (data.has_institution) {
						this.$router.push({
							name: 'mindonation',
							params: { onboarding: true }
						})
						window.analytics.track('deep_link_register', {
							organization_id: this.institution.id
						})
						facebook.track('CompleteRegistration', {
							first_name: this.user.first_name,
							last_name: this.user.last_name,
							email: this.user.email,
							value: 255.84,
							currency: 'USD'
						})
					} else {
						this.$router.push({
							name: 'mindonation',
							params: { onboarding: true }
						})
					}
				})
				.catch((error) => {
					this.isLoading = false
					this.$swal(error.message)
				})
		},
		appendToFilename(filename, string) {
			var dotIndex = filename.lastIndexOf('.')
			if (dotIndex === -1) return filename + string
			else
				return (
					filename.substring(0, dotIndex) +
					string +
					filename.substring(dotIndex)
				)
		},
		switchCause() {
			if (this.cause.uuid === this.uuid) {
				this.navigate(
					{
						name: 'home'
					},
					'forward'
				)
				return
			}
			this.isLoading = true
			this.attachInstitution(this.institution)
				.then(() => (this.isLoading = false))
				.then(() => {
					this.navigate(
						{
							name: 'home'
						},
						'forward'
					)
				})
				.catch((error) => {
					this.$swal(error.message)
				})
		},
		downgradeImage(el) {
			el.srcElement.src = this.institution.image_url
		},
		onlyNumber(evt) {
			const clean = evt.replace(/\D+/g, '')
			if (clean !== evt) {
				this.message = 'Numbers only please :)'
			} else {
				this.message = null
			}
			this.user.phone = clean
		}
	},
	mounted() {
		// eslint-disable-next-line no-console
		this.getInstitution(this.uuid)
			.then((institution) => {
				this.institution = institution
				this.noInstitution = false

				if (institution.fb_pixel_code) {
					facebook.boot(institution.fb_pixel_code)
					facebook.track('PageView')
				}

				this.$emit('updateHead')
			})
			.catch(() => {
				this.noInstitution = true
			})

		const urlParams = getUrlParams(window.location.href)
		this.user.referred_by = urlParams.referred_by
		if (urlParams.simple === 'true') {
			this.simpleForm = true
			this.user.password = Math.random().toString(36).substring(2)
			this.user.email = null
			this.user.first_name = null
			this.user.last_name = null
			this.user.phone = null
		}

		if (this.isLoggedIn && this.cause.uuid === this.uuid) {
			this.loggedInCTA = 'Go To App'
		}
	}
}
</script>

<style lang="scss" scoped>
.deep-register-view {
	.row {
		margin: 0;
	}
	width: 960px;
	left: -240px;
	margin-top: 20px;
	text-align: left;
	position: absolute;
	@media screen and (max-width: 960px) {
		width: 100%;
		left: 0px;
	}
	@media screen and (max-width: 480px) {
		margin-top: 0px;
	}
	.deep-register-btn {
		width: 84px !important;
		height: 30px !important;
	}
	h1 {
		font-size: 42px;
		font-weight: 500;
		color: #111;
		margin: 15px 0px 10px;
	}
	h2 {
		font-size: 36px;
		font-weight: 500;
		color: #111;
		margin: 10px 0px;
	}
	h3 {
		font-size: 22px;
		font-weight: 600;
		color: #111;
		margin: 10px 0px 0px;
	}
	p {
		font-family: objektiv-mk3, sans-serif;
		font-size: 18px;
		font-weight: 400;
		color: #111;
	}
	.powered-by-logo {
		background: url('../../assets/roundup_logo.svg');
		background-size: 100% auto;
		height: 15px;
		width: 150px;
		position: relative;
		p {
			color: $dark-gray;
			font-size: 12px;
			line-height: 10px;
		}
	}
	.deep-register-parts {
		display: flex;
		justify-content: center;
		@media screen and (max-width: 960px) {
			display: block;
		}
		@media screen and (max-width: 480px) {
			padding-top: 10px;
		}
	}
	.register-images {
		position: relative;
		.cover {
			min-height: 300px;
			height: 100%;
			-o-object-fit: cover;
			object-fit: cover;
			width: 100%;
		}
		img {
			border-radius: 10px 10px 0px 0px;
			width: 100%;
			@media screen and (max-width: 480px) {
				border-radius: 0px;
			}
		}
		.logo {
			max-width: 150px;
			position: absolute;
			left: 40px;
			bottom: -60px;
			border-radius: 10px;
			border: 1px solid $light-grey;
			@media screen and (max-width: 480px) {
				max-width: 125px;
				left: 40px;
				bottom: -40px;
			}
		}
	}
	.register-body {
		padding: 65px 40px 40px 40px;
		@media screen and (max-width: 480px) {
			padding: 45px 40px 40px 40px;
		}
	}
	.deep-register-half {
		padding: 0px 15px;
		flex: 4;
	}
	.deep-register-emotion {
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);

		width: auto;
		flex-shrink: 0;
		@media screen and (max-width: 960px) {
			width: auto;
		}
		@media screen and (max-width: 480px) {
			border-radius: 0px;
		}
		.register-form {
			label {
				display: block;
				margin-top: 5px;
				margin-bottom: 5px;
			}
			.terms {
				font-size: 14px;
				color: #888;
				margin-bottom: 0px;
			}
		}
	}
	.deep-register-steps {
		padding: 30px 10px 30px 30px;
		flex: 2;
		@media screen and (max-width: 480px) {
			padding: 30px;
		}
		.step {
			vertical-align: top;
			padding: 10px 0px;
			.columns {
				display: flex;
			}
		}
		p {
			margin-top: 5px;
		}
		img {
			width: 25%;
			height: 25%;
		}
	}

	.sweepstakes {
		background: $navy;
		text-align: center;
		border-radius: 10px;
		width: 100%;
		padding-bottom: 10px;
		.header {
			background-color: $banana;
			border-radius: 10px 10px 0px 0px;
			color: $navy;
			font-size: 16px;
			height: 2em;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		p {
			margin: 10px 10px;
			color: white;
			font-size: 18px;
			font-weight: 400;
			font-family: Work Sans, sans-serif;
		}
		&.subtext {
			font-size: 12px;
		}
		a {
			color: rgb(116, 109, 109);
		}
		a:after {
			color: white;
		}
	}
}
</style>
